import React, { useState, useEffect } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IsNullOrEmpty } from "../../../services/CustomService";
import { ProgressSpinner } from 'primereact/progressspinner';
import {
    Await,
    defer,
    useLoaderData,
} from "react-router-dom";
import { getPublicTools } from "../../../data/loca/tools";
export async function loader({ params }) {
   
    const tools = getPublicTools(params.userId)
    return defer({
        tools: tools,
        owner: params.userId
    });
    
}
export default function ToolsList() {
   
    const  data  = useLoaderData();

    const [filters, setFilters] = useState(null);
    const [loading] = useState(false);

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    useEffect(() => {
        
        initFilters();
    }, []);


  
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue('');
    };


    const renderHeader = () => {
        return (
            <div >


                <Await resolve={data.owner} >
                    {(owner) => (
                        <h1 className="publicToolsH1">Matériel disponible</h1>

                    )}


                </Await>

                <Await resolve={data.tools} >
                    {(tools) => (

                        <div className="contentOthersCategories">
                            {tools.otherCategories.map((item) =>
                                <div className="contentCat">
                                    <a href={ "https://lokapp.fr" + item.customUrl} className="otherCategory">
                                        <img width="197" alt={item.name} src={item.base64Picture} />
                                        <div className="watermark">
                                            {item.name}
                                        </div>
                                    </a>

                                </div>


                            )}
                            

                               
                            
                            
                        </div>


                    )}


                </Await>
                <span className="p-input-icon-left searchTool searchToolBig">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Rechercher..." />
                </span>

            </div>
        );
    };
    const smallRenderHeader = () => {
        return (
            <div >

                <span className="p-input-icon-left searchTool searchToolSmall">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Rechercher..." />
                </span>

            </div>
        );
    };
    const nameBodyTemplate = (rowData) => {

        return (
            <div className="flex align-items-center gap-2">

                {(!IsNullOrEmpty(rowData.base64Picture)) ? (
                    <img className="smallPicture" key={rowData.publicId} alt={rowData.name} src={rowData.base64Picture || null} />

                ) : (
                        <div className="no-picture no-picture-small"></div>
                )}
                <span>{rowData.name}</span>
            </div>
        );
    };

 
    const priceBodyTemplate = (rowData) => {
        return rowData.priceDayCents / 100 + "\u20ac";
    };

    const selectedTool = (rowData, baseUrl) => {
        let link = baseUrl + `/outil/`
        if (rowData.customUrl) {
            link += rowData.customUrl;
        }
        else {
            link += rowData.publicId;
        }
        window.location.href = link;

    };

    const actionBodyTemplate = (rowData, baseUrl) => {
        
        let link = baseUrl + `/outil/`
        if (rowData.customUrl) {
            link += rowData.customUrl;
        }
        else {
            link += rowData.publicId;
        }
        return (<a href={link} rel="noopener noreferrer" >
             Détails
        </a>);
    };

    const header = renderHeader();
    const smallheader = smallRenderHeader()  ;
    return (
        <div>
            <React.Suspense
                fallback={
                    <div className="card flex justify-content-center">
                    <ProgressSpinner />
                </div>}
            >
                <Await
                    resolve={data.tools}
                    errorElement={
                        <p>Erreur lors du chargement des outils !</p>
                    }
                >
                    {(tools) => (
                        <>
                            <div className="card cardDesk">

                                <DataTable value={tools.items} paginator showGridlines rows={20} loading={loading} dataKey="id" filters={filters} globalFilterFields={['name', 'brand', 'model', 'priceDayCents', 'keywords']} header={header} emptyMessage="Aucun outil trouv&eacute;">
                                    <Column header="Nom" body={nameBodyTemplate} />
                                    <Column field="brand" header="Marque" />
                                    <Column field="model" header="Mod&egrave;le" />
                                    <Column header="Prix/j" dataType="numeric" body={priceBodyTemplate} />
                                    <Column header="" body={(e) => actionBodyTemplate(e, tools.baseUrl)} />
                                </DataTable>
                           
                            </div>
                         <div className="card cardMobile">


                            <DataTable selectionMode="single" onSelectionChange={(e) => selectedTool(e.value, tools.baseUrl)}  value={tools.items} paginator showGridlines rows={20} loading={loading} dataKey="id" filters={filters} globalFilterFields={['name', 'brand', 'model', 'priceDayCents', 'keywords']} header={header} emptyMessage="Aucun outil trouv&eacute;">
                                    <Column header={smallheader} body={nameBodyTemplate} />
                            </DataTable>
                           
                            </div>


                        </>
                    )}
                </Await>
            </React.Suspense>

            
        </div>
    );
}